import { FC } from 'react';
import { Control } from 'react-hook-form';
import styled from 'styled-components';

import { Larger } from '@/components/Forms';
import Text from '@/components/Text';

import FreelancerWageField from './FreelancerWageField';
import { FormDataT } from './FreelancerWagesModal';

const Heading = styled(Text)`
  margin-bottom: 24px;
`;

interface Props {
  type: 'hour' | 'day' | 'month' | 'job';
  control: Control<FormDataT>;
}

const FreelancerWageInputs: FC<Props> = ({ control, type }) => {
  const renderWageType = () => {
    switch (type) {
      case 'hour':
        return 'Hour';
      case 'day':
        return 'Day';
      case 'month':
        return 'Month';
      case 'job':
        return 'Single Job';
    }
  };

  return (
    <Larger>
      <Heading $type="button">{renderWageType()} Wage</Heading>
      <FreelancerWageField
        currencyName={`${type}_currency`}
        amountName={`${type}_amount`}
        dateName={`${type}_wage_changed_at`}
        control={control}
        type={renderWageType()}
      />
    </Larger>
  );
};

export default FreelancerWageInputs;
